import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import IconBase from "./IconBase";
var CheckMark = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 24 : _width, _height = _param.height, height = _height === void 0 ? 25 : _height, _color = _param.color, color = _color === void 0 ? "white" : _color, props = _object_without_properties(_param, [
        "width",
        "height",
        "color"
    ]);
    return /*#__PURE__*/ _jsx(IconBase, _object_spread_props(_object_spread({
        $styles: {
            width: width,
            height: height
        },
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M7.70849 12.0787C7.31937 11.6768 6.6762 11.6723 6.28145 12.0687L6.20956 12.1409C5.81835 12.5337 5.82142 13.1698 6.21638 13.5589L10.0001 17.2861L17.2898 10.0442C17.6819 9.65466 17.6837 9.02084 17.2936 8.62917L17.2133 8.54855C16.8207 8.15423 16.1816 8.15633 15.7916 8.55321L10.0001 14.4458L7.70849 12.0787Z",
            fill: color
        })
    }));
};
export default CheckMark;
